module.exports = __webpack_public_path__ + "img/three-dots-secondary.cfaa74c6.svg";